$(document).ready(function () {
  $(".reviews-slider").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
        },
      },
    ],
  });

  $("#client-review-slide .review-text-wrapper").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 1000,
    fade: true,
    draggable: true,
    asNavFor: "#client-review-slide .review-slider-logo",
  });

  $("#client-review-slide .review-slider-logo").slick({
    slidesToShow: 3,
    arrows: false,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    centerMode: true,
    draggable: false,
    asNavFor: "#client-review-slide .review-text-wrapper",
  });

  $(".size-chart-btn").magnificPopup({
    type: "inline",
    midClick: true,
    mainClass: "mfp-fade",
  });

  // PRODUCT Tabs JS start
  // Show the first tab and hide the rest
  $(".tabs-nav li:first-child").addClass("active-tab");
  $(".tab-content").hide();
  $(".tab-content:first").show();

  $(".tabs-nav li").click(function () {
    $(".tabs-nav li").removeClass("active-tab");
    $(this).addClass("active-tab");
    $(".tab-content").hide();
    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
  });

  jQuery(document).on("click", ".deliver_button", function () {
    var zipcode = jQuery("#deliver_zipcode").val();
    var pincodeGroup1Arr = pincodegroup1.split(",");
    var pincodeGroup2Arr = pincodegroup2.split(",");
    if (zipcode != "" && zipcode != undefined) {
      jQuery(".message-text").hide();
      console.log(pincodeGroup1Arr);
      //jQuery(".check_delivery_date-popup").hide();
      //jQuery('body').removeClass('popup-open-new');
      jQuery("#deliver_zipcode").val("");
      if ($.inArray(zipcode, pincodeGroup1Arr) !== -1) {
        jQuery(".message-group1").show();
      } else if ($.inArray(zipcode, pincodeGroup2Arr) !== -1) {
        jQuery(".message-group2").show();
      } else {
        jQuery(".message-other").show();
      }
    }
  });

  // Read More Raead Less js start
  // $('.products-tabs .show-hide-btn').click(function() {
  //   $('.products-tabs .show-hide-content').toggleClass('content-vissible');
  //   console.log($('.products-tabs .show-hide-btn').text());
  //     if ($('.products-tabs .show-hide-btn').text() == "Read More") {
  //       $(this).text("Read Less")
  //     } else {
  //       $(this).text("Read More")
  //     }
  // });

  // Quality Tab js start
  $(".quality-tab-btn").magnificPopup({
    type: "inline",
    midClick: true,
    mainClass: "mfp-fade",
  });
});

$(document).on("click", ".slick--slide__zoom img", function () {
  console.log($(this).find(".zooom").html());
  $(this).parent().find(".zooom").trigger("click");
});

$(document).on("click", ".header.dismiss ", function () {
  $("#globo-formbuilder-59134").hide();
  jQuery("body").removeClass("notify-popup");
});

//SALES PAGE PRODUCT ATC JS START
$(document).ready(function () {
  $(document).on("click", ".home-product-atc", function (e) {
    e.preventDefault();
    var currentElement = $(this);
    if (currentElement.attr("data-id")) {
      var variant_id = currentElement.attr("data-id");
    } else {
      var variant_id = currentElement
        .parents(".select_bundal_wrapper")
        .find(".bundal_select_wrapper option:selected")
        .val();
      if (typeof variant_id === "undefined") {
        var variant_id = currentElement
          .parents(".bottom_footer")
          .find(".bundal_select_wrapper option:selected")
          .val();
      }
    }

    var quantity = 1;

    var itemsArray = [];
    var customItem = { id: variant_id, quantity: quantity };
    itemsArray.push(customItem);

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: { items: itemsArray },
      success: function (success_data) {
        window.location.href = "/cart";
        SLIDECART_UPDATE();
        SLIDECART_OPEN();
      },
      error: function (data) {
        alert(data.responseJSON.description);
      },
    });
  });
});

//SALES PAGE PRODUCT ATC JS END

/*
$(document).ready(function () {
  // Add click event to all elements with the class 'plus_btn'
  $('.plus_btn').on('click', function () {
    // Get the ID of the clicked button
    const buttonId = $(this).attr('id');

    // Find the corresponding product form by the same ID
    const $productForm = $(`product-form#${buttonId}`);

    if ($productForm.length) {
      // Find the submit button inside the form and trigger a click
      const $submitButton = $productForm.find('button[type="submit"]');
      if ($submitButton.length) {
        $submitButton.trigger('click');
      } else {
        console.error('Submit button not found inside form:', buttonId);
      }
    } else {
      console.error('Form not found for ID:', buttonId);
    }
  });
});
*/

$(document).on("change", '[name="Length"]', function (e) {
  if ($(this).is(":checked")) {
    var pid = $(this).attr("data-pid");
    var lendthVal = $(this).val();
    var finalVid = "";
    var mateialVal = $("#variant_box_" + pid)
      .find('[name="Material"]:checked')
      .val();
    if (mateialVal != undefined) {
      var finalVal = lendthVal + "_" + mateialVal;
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-pre");
    } else if ($("#variant_box_" + pid).find('[name="Material"]').length == 0) {
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .attr("data-pre");
    }
    if (finalVid != "") {
      if (finalVidAva == "true") {
        var addText = "Add To Cart";
        if (finalVidPre != "") {
          addText = finalVidPre;
        }
        $("#popup_btn_" + pid).removeAttr("disabled");
        $("#popup_btn_" + pid).text(addText);
        $("#home_p_hiden_id_" + pid).val(finalVid);
      } else {
        $("#popup_btn_" + pid).attr("disabled", true);
        $("#popup_btn_" + pid).text("Sold out");
      }
    }
  }
});

$(document).on("change", '[name="Material"]', function (e) {
  if ($(this).is(":checked")) {
    var pid = $(this).attr("data-pid");
    var mateialVal = $(this).val();
    var finalVid = "";
    var lengthVal = $("#variant_box_" + pid)
      .find('[name="Length"]:checked')
      .val();
    if (lengthVal != undefined) {
      var finalVal = lengthVal + "_" + mateialVal;
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-pre");
    } else if ($("#variant_box_" + pid).find('[name="Length"]').length == 0) {
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .attr("data-pre");
    }
    if (finalVid != "") {
      if (finalVidAva == "true") {
        var addText = "Add To Cart";
        if (finalVidPre != "") {
          addText = finalVidPre;
        }
        $("#popup_btn_" + pid).removeAttr("disabled");
        $("#popup_btn_" + pid).text(addText);
        $("#home_p_hiden_id_" + pid).val(finalVid);
      } else {
        $("#popup_btn_" + pid).attr("disabled", true);
        $("#popup_btn_" + pid).text("Sold out");
      }
    }
  }
});

$(document).on("change", '[name="Gender"]', function (e) {
  if ($(this).is(":checked")) {
    var pid = $(this).attr("data-pid");
    var lendthVal = $(this).val();
    var finalVid = "";
    var mateialVal = $("#variant_box_" + pid)
      .find('[name="Size"]:checked')
      .val();
    if (mateialVal != undefined) {
      var finalVal = lendthVal + "_" + mateialVal;
      console.log("----<", finalVal);
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-pre");
    } else if ($("#variant_box_" + pid).find('[name="Size"]').length == 0) {
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .attr("data-pre");
    }
    if (finalVid != "") {
      if (finalVidAva == "true") {
        var addText = "Add To Cart";
        if (finalVidPre != "") {
          addText = finalVidPre;
        }
        $("#popup_btn_" + pid).removeAttr("disabled");
        $("#popup_btn_" + pid).text(addText);
        $("#home_p_hiden_id_" + pid).val(finalVid);
      } else {
        $("#popup_btn_" + pid).attr("disabled", true);
        $("#popup_btn_" + pid).text("Sold out");
      }
    }
  }
});

$(document).on("change", '[name="Size"]', function (e) {
  if ($(this).is(":checked")) {
    var pid = $(this).attr("data-pid");
    var mateialVal = $(this).val();
    var finalVid = "";
    var lengthVal = $("#variant_box_" + pid)
      .find('[name="Gender"]:checked')
      .val();
    if (lengthVal != undefined) {
      var finalVal = lengthVal + "_" + mateialVal;
      console.log("----<", finalVal);
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .val();
      console.log("----<", finalVid);
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-pre");
    } else if ($("#variant_box_" + pid).find('[name="Gender"]').length == 0) {
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .attr("data-pre");
    }
    if (finalVid != "") {
      if (finalVidAva == "true") {
        var addText = "Add To Cart";
        if (finalVidPre != "") {
          addText = finalVidPre;
        }
        $("#popup_btn_" + pid).removeAttr("disabled");
        $("#popup_btn_" + pid).text(addText);
        $("#home_p_hiden_id_" + pid).val(finalVid);
      } else {
        $("#popup_btn_" + pid).attr("disabled", true);
        $("#popup_btn_" + pid).text("Sold out");
      }
    }
  }
});

$(document).on("change", '[name="Color"]', function (e) {
  if ($(this).is(":checked")) {
    var pid = $(this).attr("data-pid");
    var lendthVal = $(this).val();
    var finalVid = "";
    var mateialVal = $("#variant_box_" + pid)
      .find('[name="Ring size"]:checked')
      .val();
    if (mateialVal != undefined) {
      var finalVal = mateialVal + "_" + lendthVal;
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-pre");
    } else if (
      $("#variant_box_" + pid).find('[name="Ring size"]').length == 0
    ) {
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .attr("data-pre");
    }
    if (finalVid != "") {
      if (finalVidAva == "true") {
        var addText = "Add To Cart";
        if (finalVidPre != "") {
          addText = finalVidPre;
        }
        $("#popup_btn_" + pid).removeAttr("disabled");
        $("#popup_btn_" + pid).text(addText);
        $("#home_p_hiden_id_" + pid).val(finalVid);
      } else {
        $("#popup_btn_" + pid).attr("disabled", true);
        $("#popup_btn_" + pid).text("Sold out");
      }
    }
  }
});

$(document).on("change", '[name="Ring size"]', function (e) {
  if ($(this).is(":checked")) {
    var pid = $(this).attr("data-pid");
    var mateialVal = $(this).val();
    var finalVid = "";
    var lengthVal = $("#variant_box_" + pid)
      .find('[name="Color"]:checked')
      .val();
    if (lengthVal != undefined) {
      var finalVal = mateialVal + "_" + lengthVal;
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-pre");
    } else if ($("#variant_box_" + pid).find('[name="Color"]').length == 0) {
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .attr("data-pre");
    }
    if (finalVid != "") {
      if (finalVidAva == "true") {
        var addText = "Add To Cart";
        if (finalVidPre != "") {
          addText = finalVidPre;
        }
        $("#popup_btn_" + pid).removeAttr("disabled");
        $("#popup_btn_" + pid).text(addText);
        $("#home_p_hiden_id_" + pid).val(finalVid);
      } else {
        $("#popup_btn_" + pid).attr("disabled", true);
        $("#popup_btn_" + pid).text("Sold out");
      }
    }
  }
});

$(document).on("click", ".popup_btn_atc", function (e) {
  var pid = $(this).attr("data-pid");
  console.log("--->", "#" + pid + "-submit_pop_home");
  $("#" + pid + "-submit_pop_home").trigger("click");
  setTimeout(function () {
    $("#home-product-pop--" + pid).hide();
    $("#home-product-pop--" + pid).removeClass("pd_popup__open");
    $("body").removeClass("product_details_popup--active");
  }, 1000);
});

$(document).on("click", ".home-product-atc-45", function (e) {
  var pid = $(this).attr("data-id");
  $("#" + pid + "-submit-cartadd").trigger("click");
});

// PRODUCT DETAILS POPUP -- START

jQuery(document).ready(function () {
  //jQuery(".plus_btn").on("click", function () {
  jQuery(document).on("click", ".plus_btn", function () {
    const buttonId = $(this).attr("data-pid");
    $("#home-product-pop--" + buttonId).show();
    $("#home-product-pop--" + buttonId).addClass("pd_popup__open");
    $("body").addClass("product_details_popup--active");
  });
  jQuery(document).on("click", ".pd_popup_close", function () {
    const buttonId = $(this).attr("data-pid");
    $("#home-product-pop--" + buttonId).hide();
    $("#home-product-pop--" + buttonId).removeClass("pd_popup__open");
    $("body").removeClass("product_details_popup--active");
  });
});

// PRODUCT DETAILS POPUP -- END

$(".filter-tab-wrapper")
  .find(".tab-wrapper")
  .find("li")
  .on("click", function () {
    $(".filter-tab-wrapper")
      .find(".tab-wrapper")
      .find("li")
      .removeClass("active");
    $(this).addClass("active");
    $("#product-grid").find(".grid__item").hide();
    var selVal = $(this).attr("data-value");
    $("#product-grid")
      .find("." + selVal)
      .show();
  });

// COLLECTION PAGE LOAD MORE BUTTON CLICK DATA PAGINATION START JS
let $button;
let $productCountText;
let $productGrid;
let totalProducts;
let loadedProducts;
let perPage;
$(document).ready(function () {
  $button = $("#load-more");
  $productCountText = $(".product-counter-wrapper");
  $productGrid = $("#product-grid");

  if (!$button.length) return;

  totalProducts = parseInt($button.attr("data-total-products"));
  perPage = parseInt($button.attr("data-per-page"));
  loadedProducts = $productGrid.find(".grid__item").length;

  // Initialize
  toggleButtonVisibility();
  updateProductCounter();
});
//Sort change event
$(document).on("change",'[name="sort_by"]',function(){
  resetAllData();
});

//Filter All Remove Event
$(document).on("click",'.new-filter-wrapper .active-facets__button-remove,.active-facets .active-facets__button-inner',function(){
  resetAllData();
});

//Filter Price Change Event
$(document).on("keyup",'.new-filter-wrapper [name="filter.v.price.lte"]',function(){
  resetAllData();
});

function resetAllData(){
  setTimeout(function(){
    $("#load-more").attr("data-page", 2).show();
    $("#product-grid").removeClass("loading");
    $button = $("#load-more");
    $productCountText = $(".product-counter-wrapper");
    $productGrid = $("#product-grid");

    if (!$button.length) return;

    totalProducts = parseInt($button.attr("data-total-products"));
    perPage = parseInt($button.attr("data-per-page"));
    loadedProducts = $productGrid.find(".grid__item").length;

    updateProductCounter();
  },3000);
}

// Attach click event
$(document).on("click", "#load-more", function () {
  loadMoreProducts();
});

// Load More Function
function loadMoreProducts() {
  let page = parseInt($button.attr("data-page"));
  loadedProducts = $productGrid.find(".grid__item").length;
  let collectionUrl = $button.attr('data-collection-url');
  //console.log("function load page",page,loadedProducts);
  console.log("collectionUrl",collectionUrl);
  let url = window.location.origin + "/" + collectionUrl + "?page=" + page,
      queryString = window.location.search;
  //url = `${window.location.pathname}?page=${page}`;

  if (queryString) {
    let rawQueryString = queryString.substring(1);
    var mainurl = window.location.href;
    console.log("mainurl",mainurl);
    url = mainurl + "&page=" + page;
  }
  $.ajax({
    url: url,
    type: "GET",
    beforeSend: function () {
      $button.text("Loading...");
    },
    success: function (data) {
      const $newProducts = $(data).find("#product-grid .grid__item");
      // console.log("function load newProducts",$productGrid,loadedProducts);
      if ($newProducts.length) {
        $productGrid.append($newProducts);
        loadedProducts += parseInt($newProducts.length);
        page++;

        $button.attr("data-page", page);
        updateProductCounter();
        //console.log("totalProducts",totalProducts,loadedProducts);
        if (loadedProducts >= totalProducts) {
          loadedProducts = totalProducts;
          $button.hide();
          $productCountText.hide();
          $productGrid.addClass("all-products-loaded");
        } else {
          $button.text("Load More");
        }
      } else {
        $button.hide();
        $productGrid.addClass("all-products-loaded");
      }

      $(".collection--empty").remove();
    },
    error: function () {
      $button.text("Error Loading Products");
    },
  });
}

// Helper Functions
function toggleButtonVisibility() {
  if (loadedProducts >= totalProducts) {
    $button.hide();
  } else {
    $button.show();
  }
}

function updateProductCounter() {
  $productCountText.text(`Showing (${loadedProducts} of ${totalProducts} products)`);
}

// COLLECTION PAGE LOAD MORE BUTTON CLICK DATA PAGINATION END JS

$(document).on("click", ".more__discount_text span", function (e) {
  $("body").addClass("coupon_cart_drawer_open");
  startCountdown();
});

function startCountdown() {
  $(".coupon_cart_drawer .timer").each(function () {
    console.log("Timer found");
    let $this = $(this);
    let hoursToEnd = parseInt($this.data("countdown"), 10); // Get hours from data attribute
    console.log("Countdown Hours:", hoursToEnd);

    if (isNaN(hoursToEnd)) return; // Skip if invalid

    let saleEndTime = new Date().getTime() + hoursToEnd * 60 * 60 * 1000;

    function updateTimer() {
      let now = new Date().getTime();
      let timeLeft = saleEndTime - now;

      if (timeLeft > 0) {
        let hours = Math.floor(timeLeft / (1000 * 60 * 60));
        let minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        $this.find(".hours").text(hours < 10 ? "0" + hours : hours);
        $this.find(".minutes").text(minutes < 10 ? "0" + minutes : minutes);
        $this.find(".seconds").text(seconds < 10 ? "0" + seconds : seconds);
      } else {
        $this.html("<span>Sale Ended</span>");
        clearInterval(timer);
      }
    }

    updateTimer();
    let timer = setInterval(updateTimer, 1000);
  });
}

// Close the cart drawer when clicking outside of it
$(document).on("click", function (e) {
  if (
    !$(e.target).closest(".coupon_cart_drawer, .more__discount_text").length
  ) {
    $("body").removeClass("coupon_cart_drawer_open");
  }
});
$(document).on("click", ".icon-close", function () {
  $("body").removeClass("coupon_cart_drawer_open");
});

$(".copy__button").click(function () {
  let couponText = $(this).attr("data-couponcode");
  let tempInput = $("<input>");
  $("body").append(tempInput);
  tempInput.val(couponText).select();
  document.execCommand("copy");
  tempInput.remove();
});

// NEW PRODUCT PAGE DESIGN OFFER BLOCK SLIDER STRAT
$(".offer-block-slider").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  arrows: false,
  autoplaySpeed: 1000,
  draggable: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
      },
    },
  ],
});

// NEW PRODUCT PAGE DESIGN OFFER BLOCK SLIDER END

function initSlick() {
  if ($(window).width() < 801) {
    if (!$(".product-gallery-for").hasClass("slick-initialized")) {
      $(".product-gallery-for").slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        // prevArrow:"<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>",
        // nextArrow:"<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>",
      });
    }
  } else {
    if ($(".product-gallery-for").hasClass("slick-initialized")) {
      $(".product-gallery-for").slick("unslick");
    }
  }
}

$(window).on("load resize", initSlick);

// function initSlick() {
//   if ($(window).width() < 768) {
//     if (!$('.image_and_text').hasClass('slick-initialized')) {
//       $('.image_and_text').slick({
//         dots: false,
//         infinite: true,
//         arrows: true,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//          autoplay: true,
//       });
//     }
//   } else {
//     if ($('.image_and_text').hasClass('slick-initialized')) {
//       $('.image_and_text').slick('unslick');
//     }
//   }
// }

// sections/featured-tabs-new.liquid
$(document).ready(function(){
	$('ul.ftabs .ftab-link').click(function(){
		var tab_id = $(this).attr('data-tab');
		$('ul.ftabs .ftab-link').removeClass('current');
		$('.ftab-content').removeClass('current');
		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})
});


// sections/bundle-block.liquid -- START
$(window).on('load', function () {
    $('.bundle_block_main').each(function () {
        var firstGridItem = $(this).find('.bundle_block_grid .bb_grid_item').first();
        var banner = $(this).find('.bundle_block_banner');

        if (firstGridItem.length && banner.length) {
            var height = firstGridItem.outerHeight();
            banner.css('height', height + 'px');
        }
    });
});

// sections/bundle-block.liquid -- END
$(document).on("click", ".variant_btn__addtocart", function (e) {
  var pid = $(this).attr("data-pid");
  let selectedVal = $(this).attr("data-vid");
  if(selectedVal){
    console.log("--->", "#" + pid + "-submit_pop_home");
    $('#home_p_hiden_id_'+pid).val(selectedVal);
    setTimeout(function () {
      $("#" + pid + "-submit_pop_home").trigger("click");
      $("body").removeClass("product_details_popup--active");
    }, 1000);
  }
});


$(document).on("change", ".variant_select__bundle", function (e) {
  var pid = $(this).attr("data-pid");
  let selectedVal = $(this).val(); 
  if(selectedVal){
    console.log("--->", "#" + pid + "-submit_pop_home");
    $('#home_p_hiden_id_'+pid).val(selectedVal);
    setTimeout(function () {
      $("#" + pid + "-submit_pop_home").trigger("click");
      $('.variant_select__bundle').prop('selectedIndex', 0); 

      $("body").removeClass("product_details_popup--active");
    }, 1000);
  }
});

// STORE BENEFITS -- START
$('.store_benefits_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  infinite: true,
  dots: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 750,
      settings: [
        {
          slidesToShow: 1,
        }
      ]
    }
  ]
});
// STORE BENEFITS -- END




/*::::::::::::::::::::::::  Wishlist Code start here :::::::::::::::::::::::: */

// Wishlist feature: Add or remove the current product from the wishlist
jQuery(document).on("click", ".product-wish-btn.wishlist_button", function () {
  var flag='';
  if(jQuery(this).hasClass('remove_wishlist_product')){
    flag=1;
  }
  toggleWishlist(jQuery(this),flag);
});

function toggleWishlist(objClick, flag = "") {
  var optionAllval = "";
  if (flag == "") {
    optionAllval = trialcombinationVariant();
  }
  var productId = objClick.attr("data-pid");
  var ptitle = objClick.attr("data-ptitle");
  var pimage = objClick.attr("data-pimage");
  var pprice = objClick.attr("data-pprice");
  var cpprice = objClick.attr("data-cpprice");
  var pslug = objClick.attr("data-pslug");
  var productVendor = objClick.attr("data-vendor");
  var productUrl = objClick.attr("data-url");
  if (productUrl && productUrl.includes("?")) {
    productUrl = productUrl.split("?")[0];
  }
  var productSku = objClick.attr("data-sku");
  var priceNormal = objClick.attr("data-pricenormal");
  if (priceNormal == "" || priceNormal == undefined) {
    priceNormal = 0;
  }
  var variantId = objClick.attr("data-variantid");
  var cppriceNormal = objClick.attr("data-cppricenormal");
  if (cppriceNormal == "" || cppriceNormal == undefined) {
    cppriceNormal = 0;
  }
  //console.log("variantId", variantId);
  const pdpData = {
    product_title: ptitle,
    product_image: pimage,
    product_price: pprice,
    product_url: productUrl,
    variant_id:variantId,
    product_id:productId,
    price_normal:priceNormal,
    product_vendor:productVendor,
    compare_normal:cppriceNormal
  };

  let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  const isAlreadyInWishlist = wishlistData.some(
    (item) => item.variant_id === pdpData.variant_id
  );
  const wishlistButton = document.getElementsByClassName("wishlist_button")[0];
  //console.log("isAlreadyInWishlist",isAlreadyInWishlist);
  if (!isAlreadyInWishlist) {
    wishlistData.push(pdpData);
    localStorage.setItem("wishlist", JSON.stringify(wishlistData));
    // alert('Product added to wishlist:', pdpData.productTitle);
    if (flag == "") {
      wishlistButton.innerHTML = `<svg class="heart-filled" width="35px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
      </svg>`;
    }
  } else {
    wishlistData = wishlistData.filter(
      (item) => item.variant_id !== pdpData.variant_id
    );
    localStorage.setItem("wishlist", JSON.stringify(wishlistData));
    // alert('Product removed from wishlist:', pdpData.productTitle);
    if (flag == "") {
      wishlistButton.innerHTML = `<svg class="heart-outline" width="40px" height="40px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      
      <rect x="0" fill="none" width="24" height="24"/>
      
      <g>
      
      <path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/>
      
      </g>
      
      </svg>`;
    }
  }
  // Update the display after modifying the wishlist
  //displayWishlist();
  addedWishListFill();
  if (flag != "") {
    displayWishlist();
  }
}

//Remove the specified product from the wishlist
function removeFromWishlist(variantId) {
  let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  wishlistData = wishlistData.filter((item) => item.variant_id !== variantId);
  localStorage.setItem("wishlist", JSON.stringify(wishlistData));
  // Update the display after removing from the wishlist
  displayWishlist();
}

// Display wishlist items
function displayWishlist() {
  const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  //if(jQuery('.js-wishlistBlock').length!=0){
  const wishlistBlock = document.querySelector(".js-wishlistBlock");
  if (wishlistData.length === 0 && wishlistBlock!=null) {
    console.log("Wishlist is empty");
    wishlistBlock.innerHTML = "Wishlist is empty";
    wishlistBlock.classList.add('is-empty-wishlist');
    return;
  }
  var getCurrency = '';
  if(jQuery('.doubly-wrapper').find('.currency-switcher').length>0){
    getCurrency = jQuery('.doubly-wrapper').find('.currency-switcher').find('option:selected').val();
  }
  var loaderHtml = '<div class="loading-overlay__spinner hidden">';
  loaderHtml +=
    '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">';
  loaderHtml +=
    '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>';
  loaderHtml += "</svg>";
  loaderHtml += "</div>";
  const wishlistHtml = wishlistData
    .map((item) => {
      return `<li class="grid__item scroll-trigger animate--slide-in">
            <div class="wishlist-product__list card-wrapper product-card-wrapper underline-links-hover">
              <div class="card card--standard card--media" style="--ratio-percent: 125.0%;">
                <div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent: 125.0%;">
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect">
                      <button
                        class="product-wish-btn wishlist_button remove_wishlist_product"
                        data-url="${item.product_url}"
                        data-pimage="${item.product_image}"
                        data-pprice="${item.product_price}"
                        data-pricenormal="${item.price_normal}"
                        data-cppricenormal="${item.compare_normal}"
                        data-ptitle="${item.product_title}"
                        data-pid="${item.product_id}"
                        data-vendor="${item.product_vendor}"
                        data-variantid="${item.variant_id}"
                      >
                        <svg class="heart-filled" width="35px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
                        </svg>
                      </button>
                      <a href="${item.product_url}">
                        <img src="${item.product_image}" alt="${item.product_title}">
                      </a>
                    </div>
                  </div>
                  <div class="card__content">
                    <div class="card__information">
                      <h3 class="card__heading">
                        <a href="${item.product_url}" class="full-unstyled-link">${item.product_title}</a>
                      </h3>
                    </div>
                    <div class="card__badge bottom left"></div>
                  </div>
                </div>
                <div class="card__content">
                  <div class="card__information">
                    <div class="card_product_title">
                      <h3 class="card__heading h5">
                        <a href="${item.product_url}" class="full-unstyled-link">${item.product_title}</a>
                      </h3>
                    </div>
                    <div class="price">
                      <div class="price__container">
                        <div class="price__regular" style="display: none;">
                          <span class="visually-hidden visually-hidden--inline">Regular price</span>
                          <span class="price-item price-item--regular">
                            ${getCurrency} ${item.product_price}
                          </span>
                        </div>
                        <div class="price__sale">
                          <span class="visually-hidden visually-hidden--inline">Regular price</span>
                          <span><s class="price-item price-item--regular"></s></span>
                          <span class="visually-hidden visually-hidden--inline">Sale price</span>
                          <span class="price-item price-item--sale price-item--last">
                            ${getCurrency} ${item.product_price}
                          </span>
                        </div>
                        <small class="unit-price caption hidden">
                          <span class="visually-hidden">Unit price</span>
                          <span class="price-item price-item--last">
                            <span></span>
                            <span aria-hidden="true">/</span>
                            <span class="visually-hidden">&nbsp;per&nbsp;</span>
                            <span></span>
                          </span>
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>`;
    })
    .join("");

  // Add a check to ensure the element is not null before setting innerHTML
  if (wishlistBlock) {
    wishlistBlock.innerHTML = '<ul class="grid product-grid contains-card contains-card--product contains-card--standard grid--5-col-desktop grid--2-col-tablet-down" role="list">'+wishlistHtml+'</ul>';
  } else {
    //console.error('Element with class "js-wishlistBlock" not found');
  }
  //}
}

// Execute this function on DOM content load
jQuery(document).ready(function () {
  setTimeout(function(){
    addedWishListFill();
  },1000);
  // Display wishlist items
  displayWishlist();
});
var recommendTriggered = false;
jQuery(window).scroll(function(){
  if(!recommendTriggered && jQuery('.content-for-layout').find('.related-products.product-recommendations--loaded').length>0){
    var recommendSection = jQuery('.content-for-layout').find('.related-products.product-recommendations--loaded').offset().top
    //console.log("recommendSection",recommendSection);
    addedWishListFill();
    recommendTriggered = true;
  }
});

function addedWishListFill() {
  // Fetch the wishlist data from localStorage
  const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  console.log("wishlistData",wishlistData);
  // Set the initial button text based on whether the product is in the wishlist or not
  if (jQuery(".wishlist_button").length != 0) {
    const wishlistButton = document.querySelector(".wishlist_button"); // Use querySelector instead of getElementsByClassName
    const producturlArr = [];
    if (wishlistButton) {
      jQuery.each(wishlistData, function (index, product) {
        if (product.product_url != "" && product.product_url != undefined) {
          producturlArr.push(product.product_url);
        }
      });
      jQuery(".wishlist_button").each(function () {
        var productUrlwish = jQuery(this).attr("data-url");
        console.log("xproductUrlwish",productUrlwish);
        var wishStr = "";
        if (jQuery.inArray(productUrlwish, producturlArr) !== -1) {
          wishStr = `<svg class="heart-filled" width="35px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
              </svg>`;
          if (!jQuery("body").hasClass("collection")) {
            //wishStr+=`<p class="wishlist_text">In Your Wishlist</p>`;
          }
        } else {
          wishStr = `<svg width="35px" height="35px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="heart-outline">
              
              <rect x="0" fill="none" width="24" height="24"/>
              
              <g>
              
              <path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/>
              
              </g>
              
              </svg>`;
          if (!jQuery("body").hasClass("collection")) {
           // wishStr+='<p class="wishlist_text">Not In Wishlist</p>';
          }
        }
        jQuery(this).html(wishStr);
      });
    } else {
      console.error('Element with class "wishlist_button" not found');
    }
  }
}
jQuery(document).on("click", ".trial-cart-add-wishlist", function () {
  // Get the `try_cookie_product` cookie
  var match = document.cookie.match(
    new RegExp("(^| )" + "try_cookie_product" + "=([^;]+)")
  );
  var productData = match ? JSON.parse(match[2]) : [];

  if (productData && productData.length > 0) {
    var removeVariantId = jQuery(this).attr("remove-variantid");
    var productId = jQuery(this).attr("remove-pid");

    // Loop through productData and add to wishlist/remove from productData
    jQuery.each(productData, function (index, product) {
      if (product.product_id == productId) {
        let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
        wishlistData.push(product);
        localStorage.setItem("wishlist", JSON.stringify(wishlistData));

        // Remove the product from productData
        productData.splice(index, 1);

        // Break the loop since the product is found and removed
        return false;
      }
    });

    removeArrayElement(tyrHomeProductArr, "variant_id", removeVariantId);

    // Update the `try_cookie_product` cookie with the modified data
    setCookie("try_cookie_product", "", -1);
    setCookie("try_cookie_product", JSON.stringify(productData), 1);

    // Update the cart item list and UI
    trycartItemList();
    jQuery(".custom-head-trial").text(
      "HOME TRIAL CART (" + productData.length + ")"
    );

    if (productData.length == 0) {
      $(".main-drawer_footer").hide();
      if (jQuery("#total_cart").val() > 0) {
      } else {
        $(".header-and-progress").hide();
        $(".cart-home-wrapper").hide();
      }
    }

    // Show notification and update buttons
    notify("Design Added to favourite", "error");
    jQuery(".trialbtn_" + productId).hide();
    jQuery(".addedbtn_" + productId).show();
    displayWishlist();
  }
});

jQuery(document).on("click", ".cart-add-move-wishlist", function () {
  var variantId = jQuery(this).attr("data-variantid");
  removeCartProductMoveWishlist(variantId);
  toggleWishlist(jQuery(this), 1);
  jQuery("#CartDrawer-CartItems")
    .find('[data-remove="' + variantId + '"]')
    .trigger("click");
});
function trialcombinationVariant() {
  var sizeVal = (caratVal = colorVal = materialVal = "");
  var trialcombinationName = "";
  if (jQuery(".home-product-slider").length != 0) {
    var productID = jQuery(".home-product-slider .slick-active")
      .find('form [name="product-id"]')
      .val();
    sizeVal = jQuery("#product_form_" + productID)
      .find('[name="Size"]:checked')
      .val();
    if (!sizeVal) {
      sizeVal = jQuery("#product_form_" + productID)
        .find('[name="Carat"]:checked')
        .val();
    }
    if (!sizeVal) {
      sizeVal = jQuery("#product_form_" + productID)
        .find('[name="option-Carat"]:checked')
        .val();
    }

    if (!sizeVal) {
      sizeVal = jQuery("#product_form_" + productID)
        .find(".js_product_var_change option:selected")
        .attr("data-option2");
    }
    //console.log("sizeVal", jQuery('#product_form_'+productID).find('.js_product_var_change option:selected').val());
    // Get the material value
    materialVal = jQuery("#product_form_" + productID)
      .find(".js_product_var_change option:selected")
      .attr("data-option1");
    if (!materialVal) {
      materialVal = jQuery("#product_form_" + productID)
        .find('[name="option-Material"]:checked')
        .val();
    }
    // Get the color value
    colorVal = jQuery("#product_form_" + productID)
      .find('[name="Color"]:checked')
      .val();
    if (!colorVal) {
      colorVal = jQuery("#product_form_" + productID)
        .find('[name="option-Color"]:checked')
        .val();
    }
    if (!colorVal) {
      colorVal = jQuery("#product_form_" + productID)
        .find(".js_product_var_change option:selected")
        .attr("data-option3");
    }
  } else {
    if (jQuery('[name="Size"]').length > 0) {
      sizeVal = jQuery('[name="Size"]:checked').val();
    }
    if (sizeVal == "" || sizeVal == undefined) {
      sizeVal = jQuery('[name="Carat"]:checked').val();
    }
    if (sizeVal == "" || sizeVal == undefined) {
      sizeVal = jQuery('[name="option-Carat"]:checked').val();
    }
    materialVal = jQuery('[name="Material"]:checked').val();
    if (materialVal == "" || materialVal == undefined) {
      materialVal = jQuery('[name="option-Material"]:checked').val();
    }
    colorVal = jQuery('[name="Color"]:checked').val();
    if (colorVal == "" || colorVal == undefined) {
      colorVal = jQuery('[name="option-Color"]:checked').val();
    }
  }
  var replacePattern = /[\s~`!@#$%^&*(){}\[\];:"'<,>?\/\\|_+=-]/g;
  var trialcombinationValue = "";

  if (materialVal != "" && materialVal != undefined) {
    materialVal = $.trim(materialVal);
    trialcombinationValue += materialVal.replace(replacePattern, "_");
    trialcombinationName += "Material";
  }
  if (sizeVal != "" && sizeVal != undefined) {
    sizeVal = $.trim(sizeVal);
    trialcombinationValue += "###" + sizeVal.replace(replacePattern, "_");
    trialcombinationName += "###Size";
  }
  if (colorVal != "" && colorVal != undefined) {
    colorVal = $.trim(colorVal);
    trialcombinationValue += "###" + colorVal.replace(replacePattern, "_");
    trialcombinationName += "###Color";
  }
  return trialcombinationName + "@@@" + trialcombinationValue;
}
/*:::::::::::::::::::::::: Wishlist Code end here :::::::::::::::::::::::: */


